/**
 * Shop Online modal — open/close with backdrop, Esc, and close control.
 * Focus returns to the trigger; body scroll locked while open.
 */
(function () {
  var FOCUSABLE =
    'a[href], button:not([disabled]), textarea, input, select, [tabindex]:not([tabindex="-1"])';
  var openModal = null;
  var lastFocus = null;

  function getDialog(root) {
    return root.querySelector('[data-shop-online-dialog]');
  }

  function lockScroll(lock) {
    document.documentElement.classList.toggle('shop-online-modal-open', lock);
  }

  function closeModal(root) {
    if (!root || root.hasAttribute('hidden')) return;
    root.setAttribute('hidden', '');
    lockScroll(false);
    openModal = null;
    if (lastFocus && typeof lastFocus.focus === 'function') {
      lastFocus.focus();
    }
    lastFocus = null;
  }

  function openModalFor(trigger) {
    var id = trigger.getAttribute('data-shop-online-modal');
    if (!id) return;
    var root = document.getElementById(id);
    if (!root) return;

    if (openModal && openModal !== root) {
      closeModal(openModal);
    }

    lastFocus = trigger;
    root.removeAttribute('hidden');
    lockScroll(true);
    openModal = root;

    var dialog = getDialog(root);
    if (dialog) {
      dialog.focus();
    }
  }

  function trapFocus(event, root) {
    if (event.key !== 'Tab') return;
    var dialog = getDialog(root);
    if (!dialog) return;
    var nodes = Array.prototype.slice.call(dialog.querySelectorAll(FOCUSABLE)).filter(function (el) {
      return el.offsetParent !== null || el === dialog;
    });
    if (!nodes.length) {
      event.preventDefault();
      dialog.focus();
      return;
    }
    var first = nodes[0];
    var last = nodes[nodes.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  document.addEventListener('click', function (event) {
    var openBtn = event.target.closest('[data-shop-online-open]');
    if (openBtn) {
      event.preventDefault();
      openModalFor(openBtn);
      return;
    }

    var closeEl = event.target.closest('[data-shop-online-close]');
    if (closeEl) {
      var root = closeEl.closest('[data-shop-online-modal-root]');
      closeModal(root);
    }
  });

  document.addEventListener('keydown', function (event) {
    if (!openModal) return;
    if (event.key === 'Escape') {
      event.preventDefault();
      closeModal(openModal);
      return;
    }
    trapFocus(event, openModal);
  });

  var lastClickKey = '';
  var lastClickAt = 0;
  var SESSION_KEY = 'ti_wheretofind_session';
  var SEARCH_KEY = 'ti_wheretofind_search';
  var LOCATOR_LOG_URL =
    'https://docs.google.com/forms/d/e/1FAIpQLSefghmj4CVu2rwzIFd2JrZvu0_lTZgFmgWZrizHZ76mMQ45yg/formResponse';

  function locatorSessionId() {
    try {
      var existing = sessionStorage.getItem(SESSION_KEY);
      if (existing) return existing;
      var id = Math.random().toString(36).slice(2, 8);
      sessionStorage.setItem(SESSION_KEY, id);
      return id;
    } catch (err) {
      return '';
    }
  }

  function lastSearch() {
    try {
      return JSON.parse(sessionStorage.getItem(SEARCH_KEY) || 'null') || {};
    } catch (err) {
      return {};
    }
  }

  function sendLocatorLog(payload) {
    payload = payload || {};
    var prior = lastSearch();
    var fields = {
      'entry.763747866': 'click',
      'entry.1099249773': locatorSessionId(),
      'entry.1962784986': payload.action || '',
      'entry.45906970': String(prior.query || '').slice(0, 120),
      'entry.602112085': String(prior.state || '').slice(0, 40),
      'entry.1576281329': String(payload.product || prior.product || '').slice(0, 120),
      'entry.647354488': prior.results === 0 || prior.results ? String(prior.results) : '',
      'entry.1008473500': String(payload.store || '').slice(0, 120),
      'entry.491392636': String(payload.retailer || '').slice(0, 40),
      'entry.700711350': String(location.pathname || '').slice(0, 180),
    };
    var body = Object.keys(fields)
      .map(function (key) {
        return encodeURIComponent(key) + '=' + encodeURIComponent(fields[key]);
      })
      .join('&');
    try {
      fetch(LOCATOR_LOG_URL, {
        method: 'POST',
        mode: 'no-cors',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8' },
        body: body,
      });
    } catch (err) {}
  }

  function publishClick(payload) {
    sendLocatorLog(payload);
    function send() {
      if (
        window.Shopify &&
        window.Shopify.analytics &&
        typeof window.Shopify.analytics.publish === 'function'
      ) {
        window.Shopify.analytics.publish('truly_indian:store_locator_click', payload);
        return true;
      }
      return false;
    }
    if (send()) return;
    var tries = 0;
    var timer = setInterval(function () {
      tries += 1;
      if (send() || tries > 10) clearInterval(timer);
    }, 500);
  }

  if (document.documentElement.getAttribute('data-sl-click-bound') !== '1') {
    document.documentElement.setAttribute('data-sl-click-bound', '1');
    document.addEventListener(
      'click',
      function (event) {
        var el = event.target.closest && event.target.closest('[data-sl-track]');
        if (!el) return;
        var payload = {
          action: el.getAttribute('data-sl-track') || '',
          store: String(el.getAttribute('data-sl-store') || '').slice(0, 120),
          retailer: el.getAttribute('data-sl-retailer') || '',
          product: String(el.getAttribute('data-sl-product-name') || '').slice(0, 120),
        };
        if (!payload.action) return;
        var key = [payload.action, payload.store, payload.retailer, payload.product].join('|');
        var now = Date.now();
        if (key === lastClickKey && now - lastClickAt < 1000) return;
        lastClickKey = key;
        lastClickAt = now;
        publishClick(payload);
      },
      true
    );
  }
})();
